// clear-default-variant.js
// Forces no variant to be visually/functionally selected on initial product page load, and makes
// sure that "no selection yet" state doesn't visually cross out option values or reveal every
// gallery image.
//
// Runs once, after Prestige's native variant-picker.js has initialized the SSR-rendered markup for
// a true fresh page load. It intentionally does NOT re-run after a customer interacts with the
// picker: once a real selection is made, the theme fetches a fresh section render from Shopify
// (see product-gallery.liquid / option-value.liquid), and that server-rendered state is correct on
// its own and should be left alone.

document.addEventListener('DOMContentLoaded', function () {
  const pickers = document.querySelectorAll('variant-picker[context="main_product"]');

  pickers.forEach(function (picker) {
    // 1. Uncheck all radio/checkbox inputs
    picker.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
      input.checked = false;
    });

    // 2. Strip the "selected" visual class Prestige applies to swatches/blocks rendered as <a> tags
    picker.querySelectorAll('.is-selected').forEach(function (el) {
      el.classList.remove('is-selected');
    });

    // 3. Clear the "selected value" label shown next to swatch/variant_image option names
    picker.querySelectorAll('[data-color-label], .variant-picker__option-info span').forEach(function (el) {
      if (el.tagName === 'SPAN' && el.closest('.h-stack')) {
        el.textContent = '';
      }
    });

    // 4. Nothing is actually selected yet, so no option value should appear crossed out or hidden
    // just because Shopify computed availability against an implied default variant (e.g. a color
    // shouldn't cross out just because the first size in the list happens to be sold out in that
    // color). Re-enable and unhide every option value.
    picker.querySelectorAll('input[disabled]').forEach(function (input) {
      input.removeAttribute('disabled');
    });

    picker
      .querySelectorAll('.color-swatch.is-disabled, .thumbnail-swatch.is-disabled, .block-swatch.is-disabled, .block-underline.is-disabled')
      .forEach(function (el) {
        el.classList.remove('is-disabled');
      });

    picker
      .querySelectorAll('.color-swatch[hidden], .thumbnail-swatch[hidden], .block-swatch[hidden], .block-underline[hidden]')
      .forEach(function (el) {
        el.removeAttribute('hidden');
      });

    // 5. Disable Add to Cart for this product's form until a full selection is made
    const formId = picker.getAttribute('form-id');
    const form = document.getElementById(formId);
    if (!form) return;

    const addToCartBtn = form.querySelector('[name="add"], button[type="submit"]');
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.dataset.originalText = addToCartBtn.textContent.trim();
      addToCartBtn.textContent = 'Select an Option';
    }

    // 6. BUSINESS RULE: on a true fresh page load (nothing selected yet), show the merchant's
    // featured/default image PLUS every image that isn't tagged for a specific color — only
    // color-tagged images (`data-color-tagged="true"` — see product-gallery.liquid) stay hidden
    // until a color is picked. product-gallery.liquid's own server-side filtering already runs
    // using `product.selected_or_first_available_variant` as an implied default, which can end up
    // hiding images we want visible here (e.g. the featured image, if it isn't tagged for that
    // implied color). So this step doesn't just ADD `hidden` to color-tagged images — it also
    // explicitly REMOVES `hidden` from the featured image and every untagged image, to force the
    // correct "nothing selected" state regardless of what Liquid decided. Once the customer picks
    // a color, the section re-renders from the server (showing only that color's tagged images,
    // or falling back to the featured image if none match) and this step is never re-applied to
    // that new markup.
    const gallery = document.querySelector('product-gallery[form="' + formId + '"]');
    if (gallery) {
      gallery.querySelectorAll('.product-gallery__media').forEach(function (el) {
        if (el.classList.contains('is-initial') || el.getAttribute('data-color-tagged') !== 'true') {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });

      gallery.querySelectorAll('.product-gallery__thumbnail, .page-dots button').forEach(function (el) {
        if (el.getAttribute('aria-current') === 'true' || el.getAttribute('data-color-tagged') !== 'true') {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    // 7. Listen for genuine user interaction and re-enable once all options are chosen
    picker.addEventListener('change', function () {
      const fieldsets = picker.querySelectorAll('fieldset.variant-picker__option');
      const allSelected = Array.from(fieldsets).every(function (fieldset) {
        return fieldset.querySelector('input:checked');
      });

      if (allSelected && addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = addToCartBtn.dataset.originalText || 'Add to Cart';
      }
    });
  });
});
